import { Navigate, useParams, useSearchParams } from 'react-router-dom'

/**
 * Deprecated `/schools/:id/<page>` URLs now live on a hub tab. Build the target from
 * the `:id` param instead of a relative `../` path: React Router resolves `..` against
 * the route tree (the parent route is `/`), which bounced signed-in admins to `/login`.
 * Existing query parameters (such as `year`) are kept.
 */
export function SchoolHubTabRedirect({ tab }: { tab: string }) {
  const { id } = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()
  const next = new URLSearchParams(searchParams)
  next.set('tab', tab)
  return <Navigate to={`/schools/${id}?${next.toString()}`} replace />
}
